import React, { Component } from "react";
import axios from "axios";
import Helmet from "react-helmet";
import Layout from "../../Layout/layout";
import { apiHost } from "../../api/apiClient";
import NewsModal from "./newsModal";
import { formatNewsDate, getNewsPreview, getNewsReleaseDate } from "./newsContent";
import "../../styles/news/news.scss";

class NewsArchive extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      selectedItem: null,
      isLoading: true,
      error: "",
    };
  }

  componentDidMount() {
    this.loadNews();
  }

  loadNews = async () => {
    this.setState({ isLoading: true, error: "" });

    try {
      const response = await axios.get(`${apiHost}/api/News/List`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });

      this.setState({
        items: Array.isArray(response.data) ? response.data : [],
        isLoading: false,
      });
    } catch (error) {
      this.setState({
        items: [],
        isLoading: false,
        error: "Unable to load NEWS communications.",
      });
    }
  };

  getAuthHeaders() {
    return {
      Authorization: "Bearer " + localStorage.getItem("token"),
    };
  }

  openNews = async (item) => {
    this.setState({ selectedItem: item, error: "" });

    try {
      const contentRequest = axios.get(`${apiHost}/api/News/${item.id}`, {
        headers: this.getAuthHeaders(),
      });
      const acknowledgementRequest = item.readUtc
        ? Promise.resolve({ data: { readUtc: item.readUtc } })
        : axios.post(
            `${apiHost}/api/News/${item.id}/Acknowledge`,
            { version: item.version },
            {
              headers: this.getAuthHeaders(),
            }
          );

      const [contentResponse, acknowledgementResponse] = await Promise.all([contentRequest, acknowledgementRequest]);
      const readUtc = acknowledgementResponse.data && acknowledgementResponse.data.readUtc ? acknowledgementResponse.data.readUtc : item.readUtc || new Date().toISOString();
      const fullItem = { ...item, ...(contentResponse.data || {}), readUtc };

      this.setState((state) => ({
        items: state.items.map((newsItem) => (newsItem.id === item.id ? { ...newsItem, readUtc } : newsItem)),
        selectedItem: state.selectedItem && state.selectedItem.id === item.id ? fullItem : state.selectedItem,
      }));
    } catch (error) {
      this.setState({ error: "Unable to load this communication." });
      console.log(`News detail request failed: ${error}`);
    }
  };

  closeNews = () => {
    this.setState({ selectedItem: null });
  };

  renderTile(item) {
    const preview = getNewsPreview(item);

    return (
      <button className="news-tile" key={item.id} onClick={() => this.openNews(item)} type="button">
        <div className="news-tile-meta">
          <span>{item.contentType}</span>
          <time>{formatNewsDate(getNewsReleaseDate(item))}</time>
        </div>
        <div className="news-tile-content">
          <div className="news-tile-heading">
            <h3>{item.title}</h3>
            {item.readUtc && <div className="news-tile-read">Read on {formatNewsDate(item.readUtc)}</div>}
          </div>
          <p>{preview}</p>
        </div>
      </button>
    );
  }

  render() {
    return (
      <Layout>
        <Helmet>
          <title>News</title>
        </Helmet>
        <div className="news-report-page">
          <div className="news-report-shell news-archive-shell">
            <div className="news-report-header news-archive-header">
              <div className="news-hero-broadcast" aria-hidden="true">
                <span />
                <span />
                <span />
              </div>
              <div className="news-hero-copy">
                <div className="news-report-eyebrow">Communications</div>
                <h2>News</h2>
                <p>Latest communications from VisionTrak.</p>
              </div>
              <div className="news-hero-graphic" aria-hidden="true">
                <div className="news-bulletin-screen">
                  <div className="news-bulletin-topbar">
                    <span>LIVE</span>
                    <i />
                  </div>
                  <div className="news-bulletin-body">
                    <div className="news-bulletin-signal">
                      <span />
                      <span />
                      <span />
                    </div>
                    <div className="news-bulletin-lines">
                      <span />
                      <span />
                      <span />
                    </div>
                  </div>
                  <div className="news-bulletin-ticker">
                    <span>NEWS UPDATE</span>
                  </div>
                </div>
              </div>
              <div className="news-hero-ticker" aria-hidden="true">
                <div className="news-hero-ticker-track">
                  <div className="news-hero-ticker-group">
                    <span>VisionTrak News Bulletin</span>
                    <i>Latest communications, product updates and service notices</i>
                    <span>Live Updates</span>
                    <i>Latest communications, product updates and service notices</i>
                  </div>
                  <div className="news-hero-ticker-group">
                    <span>VisionTrak News Bulletin</span>
                    <i>Latest communications, product updates and service notices</i>
                    <span>Live Updates</span>
                    <i>Latest communications, product updates and service notices</i>
                  </div>
                </div>
              </div>
            </div>

            {this.state.error && <div className="news-report-status news-report-status-error">{this.state.error}</div>}
            {this.state.isLoading && <div className="news-empty">Loading NEWS...</div>}
            {!this.state.isLoading && this.state.items.length === 0 && (
              <div className="news-empty">No communications have been published yet.</div>
            )}

            <div className="news-grid news-archive-grid">{this.state.items.map((item) => this.renderTile(item))}</div>
          </div>
        </div>
        <NewsModal item={this.state.selectedItem} show={!!this.state.selectedItem} onHide={this.closeNews} />
      </Layout>
    );
  }
}

export default NewsArchive;
